export default {
    must_field: "Field must be filled",
    field_can_not_be_updated: "Insert range has a column with read-only date, impossible to insert data to this column",
    invalid_value: "Value is incorrect",
    error_in_form_before_submit: "Unable to send data to the server",
    company_validation_bad_name: "Name must be filled in",
    account_transfer_not_balanced: "Operations must be balanced",
    wrong_credentials: "Access denied",
    cam_media_error: "Camera is unavailable",
    err_on_upload_camera_photo: "Photo uploading failed",
    unauthorized: "Access forbidden",
    "Error: not_deletable_account": "The invoice cannot be deleted",
    "Error: account_has_transfers": "This invoice does not have an accounting entry",
    "Error: account_has_children": "This invoice has subinvoices",
    ajax_error: "Failed connection to the server",
    unique_LIST_COMPANY_inn: "This VAT is already occupied",
    unique_LIST_COMPANY_inn_kpp: "Branch with this INN and KPP already exists",
    unique_LIST_COMPANY_contacts: "Such Company already exist",
    unique_INVOICE_INCOMING_doc_number: "Invoice already exists",
    unique_INVOICE_OUTGOING_doc_number: "Invoice already exists",
    unique_LIST_USER_login: "Such login already exists",
    unique_OWNER_UNIT_unit_number: "Such rolling stock already exists",
    unique_OWN_ROLLING_STOCK_UNIT_unit_number: "Such rolling stock already exists",
    email_cant_be_send: "Failed to send email",
    no_selected_elements: "There is no selected item",
    on_remove_constraint_relation_error: "Cannot be deleted because there are dependent rows",
    EA0x0001: "No rights to delete rows with the following numbers of entries: {=rows}",
    EA0x0002: "No rights to restore the rows with the following numbers of entries: {=rows}",
    EA0x0003: "No rights to move the cart lines with the following numbers of entries: {=rows}",
    access_denied_trash_task_by_not_creator: "You can't delete these tasks: {=rows}",
    access_denied_untrash_task_by_not_creator: "You can't recover these tasks: {=rows}",
    access_denied_remove_task_by_not_creator: "You can't delete these tasks: {=rows}",
    order_no_units: "This order has no transfer units",
    "new row for relation \"list_order_positions\" violates check constraint \"valid_quantity_sum\"":
        "Exceeded the maximum number of goods",
    order_has_no_units_related_to_declaration: "It is impossible to tie - no loading units with this number in Order",
    import_error_500: "An error occurred while downloading a file, check the file format",
    import_classes_invalid_attrs_map_file: "The mapping file to import an excel database is missing or contains errors",
    import_classes_invalid_excel_file: "The exported excel file has an incorrect format.",
    import_classes_columns_not_recognized: "Can not recognize excel columns",
    import_classes_update_invalid_part_number: "Error while update column with part number # '{= part_number}'",
    import_classes_insert_invalid_part_number: "Error while insert column with part number # '{= part_number}'",
    on_remove_invoice_that_has_closing_documents_error: "You have no permission to delete the invoice, it already has closing documents",
    on_remove_invoice_that_has_archived_order_error: "You have no permission to delete the invoice, it is attached to an archived order",
    on_remove_invoice_that_statement_date_less_then_fin_settings_date_error: "You have no permission to delete the invoice, it belongs to a closed period",
    on_remove_invoice_that_has_an_actual_payment_date_error: "You cannot delete the account for which is determined by the actual date of payment",
    on_restore_mirror_invoice_when_outgoing_invoice_is_deleted: "The mirror invoice can't be restored, the original invoice is deleted",
    system_status_delete_error: "Cannot delete system status",
    system_status_update_error: "You cannot change system status",
    no_rights_to_order_archiving:
        "The deviation of the actual return on plan more than 5%! You cannot move the order to the archive.",
    not_get_to_order_archiving:
        "Impossible to get the order from the archive. The deviation of the actual margin from planned is more than 5%!",
    model_should_inherit_from_RowModel: "model must inherit from the RowModel",
    error_creating_model: "Error when creating models",
    cant_remove_or_update_status: "You cannot edit or delete system status",
    "no documents": "The document list is empty",
    server_timeout: "Timeout while waiting for response from the server",
    dont_remove_system_capital_account: "You cannot edit or delete invoice created by system automatically",
    dont_remove_account_with_operations: "You cannot delete fin.invoice with records",
    wrong_account_type_child: "Fin.zccount type must be the same parent",
    wrong_account_liquidity_child: "Liquidity of fin.account must be the same parent",
    wrong_account_currency_child: "Fin.account currency of descendant must be the same parent",
    wrong_account_type_parent: "Fin.account type of descendant must be the same parent",
    wrong_account_liquidity_parent: "Liquidity of fin. account of descendant must be the same parent",
    wrong_account_currency_parent: "Currency of fin.account of descendant must be the same parent",
    null_json: "Transaction should have operations",
    need_currency: "Transactions should have indicated currency",
    expected_two_operations: "In transactions should be not more that 2 operations",
    expected_single_currency: "All operations should be in the same currency",
    need_debet_or_credit: "Every operations should have debit or credit",
    only_debet_or_credit: "Operation may have only debit or only credit",
    wrong_debet_credit_sum: "Debit shuld be equal to credit",
    dont_update_operation_id_account: "You cannot change account for transaction",
    account_with_balance_cannot_have_children: "The account cannot have descendants if he does not a zero balance",
    invalid_liquidity: "Liquidity should correspond to the account type",
    dont_remove_part_number: "You cannot delete invoice with recorded links",
    dont_to_untie_part_number: "Cannot untie cargo unit whith issued invoice",
    dont_edit_part_number: "Cannot edit as invoice has been issued",
    error_client_and_preclient_role: "You cannot assign \"Customer\" and \"Potential Customer\" role at the same time",
    single_start_point_if_more_than_one_end_point:
        "You cannot select more than one departure if you have selected more than one destination",
    no_unique_list_company_name: "The counterparty with the name '{=companyName}' already exists",
    company_already_exists: "The company already exists",
    inn_error: "No matches of Tax ID",
    no_unique_list_company_inn: "The counterparty with Tax ID n{=inn} already exists",
    fin_oper_has_untrashed_invoices_error: "You can't remove the fin. the operation with issued invoice",
    fin_oper_has_untrashed_invoices_on_clear_error: "You can't clear the rates in fin. operation with issued invoice",
    payment_order_has_untrashed_invoices_error: "You cannot remove payment record consisting invoices",
    no_edit_total_sum_vat_for_foreign_currency_position:
        "VAT amount of position where currency differs from invoice currency cannot be edited",
    dont_remove_operation_unit: "You cannot remove cargo with registered invoice",
    must_first_apply_the_changes: "You need to apply changes first",
    contracts_fea_addition_is_main_must_be_only_one: "The main additional agreement can only be one!!",
    cannot_delete_template_attached_log_scheme: "You cannot delete a template which connected to the Logistics plan",
    "can_not_change_start/end_point_of_train_whith_unit":
        "You cannot change the station of departure/arrival of the train with cargo",
    not_unique_mmsi: "This MMSI already in use",
    not_unique_bik: "The BIC is already in use",
    has_linked_unit_on_next_operation: "There are related goods for subsequent operations",
    owner_unit_number_exists: "Export to {=unit_number} there are",
    visible_sum_of_docs_of_fin_operation_more_then_visible_sum_of_fin_operation:
        "Summ cost linked docs can't be more then sum of fin operation",
    delete_system_tab_error: "You cannot delete system tab #{=id}",
    trash_manager_bonus_rec_error: "Cannot remove record while \"Period Closed\" is checked",
    trash_linked_rec_with_manager_bonus_closed_period_error: "You have no permission to delete the invoice, it belongs to a closed period",
    actual_date_coming_not_current_date: "Order archive date not current_date",
    actual_date_logist_complete_not_current_date: "Cannot enter a date other than the current one.",
    wrong_doc_date: "Wrong doc date",
    unique_constraint_service_for_resubmission_index: "The field “Service for resubmission” can be filled only on one item",
    sum_payment_more_then_gtd_sum_diff: "Amount paid exceeds balance (declarations)",
    sum_payment_more_then_payment_orders_sum_diff: "Amount paid exceeds balance of the SWIFT",
    repetitions_of_category: "These fields match the existing Service item categories: {=names}",
    unique_service_combination_name: "This Name matches the existing Service combination",
    same_service_combination: "These fields match the existing Service combination",
    duplicate_sys_serial_number: "This order number already exists"
};
